document.addEventListener('click', e => {
    const c = e.target.closest('.expand-block');
    if (!c) return;

    const isExpand = e.target.classList.contains('expand-btn');
    const isCollapse = e.target.classList.contains('collapse-btn');

    if (isExpand || isCollapse) {
        c.querySelector('.hidden-text').classList.toggle('hidden');
        c.querySelector('.expand-btn').classList.toggle('hidden');
        c.querySelector('.collapse-btn').classList.toggle('hidden');
    }
});